import FirestoreDocument from "../../../types/FirestoreDocument";
import { string } from "../../../types/_types";

export const OrganizationRef = FirestoreDocument.extend({
	name: string(),
	type: string(),
});
